import { requests } from './agent'
import { HttpResponse } from '../models/http/Reponse'
import { Auction } from '../models/Auction'
import { HomeFilter } from '../models/Filter'
import { Post } from '../models/Post'

type AuctionOrPost = Auction | Post

interface AuctionOrPostResponse extends HttpResponse {
  data: AuctionOrPost[]
}

const HomeFiltering = {
  list: (filter: HomeFilter) => requests.post<AuctionOrPostResponse>('/Filter', filter),
}

export default HomeFiltering
